import { useState, useCallback, useEffect } from 'react';
import { fetchGatewayListFromDB } from '../../../api';

/**
 * Hook for managing gateway list
 */
export function useGateways(setFormData) {
  const [gateways, setGateways] = useState([]);

  // Load gateways list
  const loadGateways = useCallback(async () => {
    try {
      const dbGateways = await fetchGatewayListFromDB();
      const normalized = (dbGateways || []).map((gw) => ({
        id: gw.id,
        name: gw.name,
      }));
      setGateways(normalized);

      // prefill gateway for new port
      setFormData((prev) => {
        if (prev.gateway_id) return prev;
        if (normalized.length > 0) {
          return { ...prev, gateway_id: normalized[0].id };
        }
        return prev;
      });
    } catch (err) {
      console.error('Failed to load gateway list:', err);
    }
  }, [setFormData]);

  useEffect(() => {
    loadGateways();
  }, [loadGateways]);

  return { gateways };
}


